import * as types from "state/entities/userTeamAudios/userTeamAudiosTypes";
import { formatErrors, getPath, omit } from "lib";

export const initState = {
  audios: {
    pages: {
      /* isFetching: true|false
       * ids:[]
       * didInvalidate: true|false */
    },
    detailedIds: {},
    totalCount: null
  },
  all: {
    pages: {
      /* isFetching: true|false
       * ids:[]
       * didInvalidate: true|false */
    },
    detailedIds: {},
    totalCount: null
  },
  folders: {
    //  folderId: {
    //    audios: {
    //     pages: {
    //       isFetching: true|false
    //       ids:[]
    //       didInvalidate: true|false
    //     }
    //    },
    //    all: {
    //     pages: {
    //       isFetching: true|false
    //       ids:[]
    //       didInvalidate: true|false
    //     }
    //   }
    // }
  },
  totalCount: null,
  pageSize: 50,
  errors: null
};

export const handleUserTeamAudioInFolderRequest = ({ action, state }) => {
  const { folderId, page } = action.request.params;
  const assetType = "audios"; // Audio files are always "audios" type

  return {
    ...state,
    folders: {
      ...state.folders,
      [folderId]: {
        ...state.folders[folderId],
        [assetType]: {
          ...getPath(state.folders, `${folderId}.${assetType}`),
          pages: {
            ...getPath(state.folders, `${folderId}.${assetType}.pages`),
            [page]: {
              ...getPath(
                state.folders,
                `${folderId}.${assetType}.pages.${page}`
              ),
              isFetching: true
            }
          }
        }
      }
    }
  };
};

export const handleAllUserTeamAudioRequest = ({ action, state }) => {
  const { page } = action.request;

  return {
    ...state,
    all: {
      ...state.all,
      pages: {
        ...state.all.pages,
        [page]: {
          ...state.all.pages[page],
          isFetching: true
        }
      }
    }
  };
};

export const handleUserTeamAudioRequest = ({ action, state }) => {
  const { page } = action.request;

  return {
    ...state,
    audios: {
      ...state.audios,
      pages: {
        ...state.audios.pages,
        [page]: {
          ...state.audios.pages[page],
          isFetching: true
        }
      }
    }
  };
};

export const handleAllUserTeamAudioRequestSuccess = ({ action, state }) => {
  const {
    response: { ids, result },
    request: { page }
  } = action;

  // Use ids from normalizr response, fallback to result if needed
  const audioIds = ids || result;

  return {
    ...state,
    all: {
      ...state.all,
      pages: {
        ...state.all.pages,
        [page]: {
          ids: audioIds,
          isFetching: false,
          didInvalidate: false
        }
      }
    }
  };
};

export const handleUserTeamAudioRequestSuccess = ({ action, state }) => {
  const {
    response: { ids, result },
    request: { page }
  } = action;

  // Use ids from normalizr response, fallback to result if needed
  const audioIds = ids || result;

  return {
    ...state,
    audios: {
      ...state.audios,
      pages: {
        ...state.audios.pages,
        [page]: {
          ids: audioIds,
          isFetching: false,
          didInvalidate: false
        }
      }
    }
  };
};

export const handleUserTeamAudioInFolderRequestSuccess = ({
  action,
  state
}) => {
  const {
    response: { ids, result },
    request: { params }
  } = action;
  const { folderId, page } = params;
  const assetType = "audios";

  // Use ids from normalizr response, fallback to result if needed
  const audioIds = ids || result;

  return {
    ...state,
    folders: {
      ...state.folders,
      [folderId]: {
        ...state.folders[folderId],
        [assetType]: {
          ...getPath(state.folders, `${folderId}.${assetType}`),
          pages: {
            ...getPath(state.folders, `${folderId}.${assetType}.pages`),
            [page]: {
              ids: audioIds,
              isFetching: false,
              didInvalidate: false
            }
          }
        }
      }
    }
  };
};

export const handleUploadUserTeamAudioRequestSuccess = ({
  state,
  stateProperty,
  pageIndex,
  mediaId
}) => {
  const currentPage = getPath(state, `${stateProperty}.pages.${pageIndex}`);
  const currentPageIds = currentPage?.ids || [];

  return {
    ...state,
    [stateProperty]: {
      ...state[stateProperty],
      pages: {
        ...state[stateProperty].pages,
        [pageIndex]: {
          ...currentPage,
          ids: [mediaId, ...currentPageIds]
        }
      }
    }
  };
};

export const handleUserTeamAudioRequestFailure = ({ action, state }) => {
  const { errors } = action;
  const { page } = action.request;

  return {
    ...state,
    audios: {
      ...state.audios,
      pages: {
        ...state.audios.pages,
        [page]: {
          ...state.audios.pages[page],
          isFetching: false,
          errors: formatErrors(errors)
        }
      }
    },
    errors: formatErrors(errors)
  };
};

export const handleAllUserTeamAudioRequestFailure = ({ action, state }) => {
  const { errors } = action;
  const { page } = action.request;

  return {
    ...state,
    all: {
      ...state.all,
      pages: {
        ...state.all.pages,
        [page]: {
          ...state.all.pages[page],
          isFetching: false,
          errors: formatErrors(errors)
        }
      }
    },
    errors: formatErrors(errors)
  };
};

const userTeamAudiosApiReducers = (state = initState, action) => {
  switch (action.type) {
    case types.ALL_USER_TEAM_AUDIOS_REQUEST: {
      return handleAllUserTeamAudioRequest({ state, action });
    }

    case types.USER_TEAM_AUDIOS_REQUEST: {
      return handleUserTeamAudioRequest({ state, action });
    }

    case types.ALL_USER_TEAM_AUDIOS_REQUEST_SUCCESS: {
      return handleAllUserTeamAudioRequestSuccess({ state, action });
    }

    case types.USER_TEAM_AUDIOS_REQUEST_SUCCESS: {
      return handleUserTeamAudioRequestSuccess({ state, action });
    }

    case types.USER_TEAM_AUDIOS_IN_FOLDER_REQUEST: {
      return handleUserTeamAudioInFolderRequest({ state, action });
    }

    case types.USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_SUCCESS: {
      return handleUserTeamAudioInFolderRequestSuccess({ state, action });
    }

    case types.ALL_USER_TEAM_AUDIOS_REQUEST_FAILURE: {
      return handleAllUserTeamAudioRequestFailure({ state, action });
    }

    case types.USER_TEAM_AUDIOS_REQUEST_FAILURE: {
      return handleUserTeamAudioRequestFailure({ state, action });
    }

    case types.ADD_USER_TEAM_AUDIOS_PLACEHOLDERS: {
      const { mediaPlaceholders } = action;
      const assetType = "audios";

      const currentPageIds = getPath(state, `${assetType}.pages.1.ids`) || [];
      const placeholderIds = mediaPlaceholders.map(
        placeholder => placeholder.mediaId
      );

      return {
        ...state,
        [assetType]: {
          ...state[assetType],
          pages: {
            ...state[assetType].pages,
            1: {
              ...state[assetType].pages[1],
              ids: [...placeholderIds, ...currentPageIds]
            }
          }
        }
      };
    }

    case types.USER_TEAM_AUDIO_DELETE_REQUEST: {
      const { mediaId } = action.request;
      const assetType = "audios";

      const currentAudiosPages = state[assetType].pages;
      const updatedPages = {};

      Object.keys(currentAudiosPages).forEach(pageKey => {
        const page = currentAudiosPages[pageKey];
        if (page.ids) {
          updatedPages[pageKey] = {
            ...page,
            ids: page.ids.filter(id => id !== mediaId)
          };
        } else {
          updatedPages[pageKey] = page;
        }
      });

      return {
        ...state,
        [assetType]: {
          ...state[assetType],
          pages: updatedPages
        }
      };
    }

    case types.USER_TEAM_AUDIO_UPLOAD_REQUEST_SUCCESS: {
      const { mediaId } = action.response;

      if (!mediaId) return state;

      // Add to all.pages since that's where we fetch from
      const allPages = getPath(state, `all.pages`);
      const allPageNumber = allPages ? Object.keys(allPages).length : 1;

      return handleUploadUserTeamAudioRequestSuccess({
        state,
        stateProperty: "all",
        pageIndex: allPageNumber,
        mediaId
      });
    }

    case types.CLEAR_USER_TEAM_AUDIO_UPLOAD_ERRORS: {
      const { errors } = state;

      if (!errors) return state;

      return omit(state, "errors");
    }

    case types.USER_TEAM_AUDIOS_CLEAR: {
      return initState;
    }

    default:
      return state;
  }
};

export default userTeamAudiosApiReducers;
